exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-product-name[data-v-3086aa84] {\n  margin-bottom: 16px;\n  color: #606266;\n}\n", ""]);

// exports
